import { t } from '../i18n/index.js'

const RADIUS = 22
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

/**
 * One glance at how the day stands.
 *
 * Minijobber are the group that gets the least feedback of anyone in this
 * product; a visible finish line is worth more here than another statistic.
 */
export function DayProgress({ done, total }: { done: number; total: number }) {
  if (total === 0) return null

  const ratio = done / total
  const allDone = done === total

  return (
    <div className={`wk-progress ${allDone ? 'all-done' : ''}`}>
      <svg className="ring" viewBox="0 0 54 54" role="img" aria-label={t('progress.done_of', { done, total })}>
        <circle className="track" cx="27" cy="27" r={RADIUS} />
        <circle
          className="value"
          cx="27"
          cy="27"
          r={RADIUS}
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={CIRCUMFERENCE * (1 - ratio)}
          transform="rotate(-90 27 27)"
        />
        <text x="27" y="31" textAnchor="middle">
          {done}/{total}
        </text>
      </svg>
      <div>
        <div className="label">{allDone ? t('progress.all_done') : t('progress.remaining', { count: total - done })}</div>
        <div className="sub">
          {allDone ? t('progress.none_left') : t('progress.done_of', { done, total })}
        </div>
      </div>
    </div>
  )
}
